<select #countrySelector (change)="selectItem(countrySelector.value)" class="form-control">
  <option *ngIf = "!required" value=""></option>
  <option [selected]="itm.key === selectedItem" value="{{itm.key}}" *ngFor="let itm of countryList | objectToArray | sortBy: ['text']">{{itm.text}}</option>
</select>
